import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Drawer,
  FormControl,
  FormControlLabel,
  FormLabel,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextInput from "../../../components/TextInputs";
import appcolors from "../../../constants/Colors";
import { setTabActive } from "../../../lib/slices/tabActiveSlice";
import {
  createAppointment,
  createClient,
} from "../../../services/appointments";
import { searchClients } from "../../../services/Auth";
import DrawerSteps from "./DrawerSteps";

const drawerWidth = 700;

export default function CategoryDrawer({
  onClose,
  setIsLoading,
  handleSnackbarVal,
  setIsDrawerOpen,
  isDrawerOpen,
}) {
  const dispatch = useDispatch();
  const tabActive = useSelector((state) => state.tabActive.tabs);
  const { user } = useSelector((state) => state.user);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [selectedProfessional, setSelectedProfessional] = useState(null);
  const [appointmentDateTime, setAppointmentDateTime] = useState(null);
  const [allTeamMembers, setAllTeamMembers] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [payloadData, setPayloadData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [verificationLoading, setVerificationLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  console.log(filteredClients, "filteredClientsfilteredClientsfilteredClients");

  const [openModal, setOpenModal] = useState(false);
  const [newClient, setNewClient] = useState({
    username: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    gender: "",
  });

  useEffect(() => {
    if (!openModal) {
      setNewClient({
        username: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmPassword: "",
        gender: "",
      });
      setOtp(["", "", "", "", "", ""]);
    }
  }, [openModal]);

  useEffect(() => {
    if (!isDrawerOpen) {
      setSelectedClient(null);
      setSelectedProfessional(null);
      setSelectedServices([]);
      setSelectedIds([]);
      setPayloadData([]);
      setAppointmentDateTime(null);
      setSelectedTime(null);
      setSelectedDate(null);
      dispatch(setTabActive(0));
    }
  }, [isDrawerOpen]);
  useEffect(() => {
    if (searchQuery) {
      const lowerCaseQuery = searchQuery.toLowerCase();
      const filtered = clients?.filter(
        (client) =>
          client?.username?.toLowerCase()?.includes(lowerCaseQuery) ||
          client?.email?.toLowerCase()?.includes(lowerCaseQuery) ||
          client?.contact?.toLowerCase()?.includes(lowerCaseQuery)
      );
      setFilteredClients(filtered || []);
    }
  }, [searchQuery, clients]);

  const handleCreateTeamData = (payload) => {
    setAllTeamMembers(payload?.allTeams);
    setSelectedServices(payload?.selectedServices);
    setSelectedIds(payload?.selectedIds);
  };

  const handleSelectTeam = (data) => {
    setPayloadData(data);
  };

  const handleSelectedDateTime = (date, time) => {
    setSelectedTime(time);
    setSelectedDate(date);
  };

  const handleCreateAppointment = async () => {
    try {
      if (selectedClient) {
        let startTime = moment(
          selectedDate + " " + selectedTime,
          "YYYY-MM-DD hh:mm A"
        ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");

        let payload = {
          businessID: user?._id,
          branchID: selectedBranch[0],
          userID: selectedClient?._id,
          services: payloadData,
          appointmentType: "Walk-In",
          startTime: startTime,
          appointmentDate: startTime,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
        setIsLoading(true);
        const response = await createAppointment(payload);
        setIsLoading(false);
        if (response.status == 200 || response.status == 201) {
          setIsDrawerOpen(false);
          handleSnackbarVal(true, "success", response.data.message);
        } else {
          handleSnackbarVal(true, "error", response.data.message);
        }
      } else {
        handleSnackbarVal(true, "error", "Please select a client first");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error, "errorerrorerrorerror");
      handleSnackbarVal(true, "error", "Appointment creation failed");
    }
  };

  const handleAddClient = async () => {
    const { phoneNumber, username } = newClient;
    if (!username) {
      handleSnackbarVal(true, "error", "User name is required");
    } else if (!phoneNumber) {
      handleSnackbarVal(true, "error", "Contact is required");
    } else {
      try {
        let payload = {
          username: newClient.username,
          contact: `+${newClient.phoneNumber}`,
          email: newClient.email,
          password: "123456",
          gender: newClient.gender,
          type: "register",
        };

        setIsLoading(true);
        const response = await createClient(payload);
        setIsLoading(false);

        if (response.status == 200 || response.status == 201) {
          setOpenModal(false);
          handleSnackbarVal(true, "success", response.data.message);
          handleClientSelection(response.data.data.userDetails);
          let addedUser = [response.data.data.userDetails, ...clients];
          setClients(addedUser);
          setFilteredClients(addedUser);
        } else {
          handleSnackbarVal(true, "error", response.data.message);
        }
      } catch (error) {
        setIsLoading(false);
        handleSnackbarVal(true, "error", "Client creation failed");
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewClient((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearchClient = async () => {
    try {
      if (searchQuery) {
        setIsLoading(true);
        const response = await searchClients({
          searchText: searchQuery,
        });
        console.log("Search Response:", response?.data);

        setIsLoading(false);
        if (response.status == 200 || response.status == 201) {
          let reverseResponse = response?.data?.reverse() || [];
          setClients(reverseResponse);
          setFilteredClients(reverseResponse);
        } else {
          handleSnackbarVal(true, "error", response?.data?.message);
        }
      } else {
        setClients([]);
        setFilteredClients([]);
        handleSnackbarVal(
          true,
          "error",
          "Please search with username, email or phone number"
        );
      }
    } catch (error) {
      console.error("Error searching clients:", error);
      setIsLoading(false);
    }
  };

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      handleSearchClient();
    }
  };

  const handleClientSelection = (client) => {
    setSelectedClient(client);
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="add-client-modal"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 2,
            maxWidth: 400,
            width: "90%",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Add New Client
          </Typography>

          <TextInput
            fullWidth
            type="text"
            name="username"
            placeholder="Username"
            value={newClient.username}
            onChange={handleInputChange}
            style={{ marginBottom: 10 }}
          />

          <TextInput
            name="phoneNumber"
            placeholder="05xxxxxxxx"
            value={newClient.phoneNumber}
            onChange={(e) =>
              setNewClient({ ...newClient, phoneNumber: e.target.value })
            }
            variant="outlined"
            size="small"
            style={{ marginBottom: 10 }}
            type="number"
            required={true}
          />

          <TextInput
            fullWidth
            name="email"
            label="Email "
            placeholder="Email (Optional)"
            type="email"
            value={newClient.email}
            onChange={handleInputChange}
            style={{ marginBottom: 10 }}
          />

          <FormControl component="fieldset" sx={{ mb: 2 }}>
            <FormLabel sx={{ display: "flex", alignItems: "center" }}>
              Gender
              <Typography fontSize={10} mt={0.3} ml={1}>
                (Optional)
              </Typography>
            </FormLabel>
            <RadioGroup
              row
              name="gender"
              value={newClient.gender || ""}
              onChange={handleInputChange}
            >
              <FormControlLabel value="male" control={<Radio />} label="Male" />
              <FormControlLabel
                value="female"
                control={<Radio />}
                label="Female"
              />
            </RadioGroup>
          </FormControl>

          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
            <Button variant="outlined" onClick={() => setOpenModal(false)}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleAddClient}>
              Add Client
            </Button>
          </Box>
        </Box>
      </Modal>

      <IconButton
        sx={{
          position: "fixed",
          top: "10px",
          right: `${drawerWidth + 30}px`,
          zIndex: 1300,
          bgcolor: "background.paper",
          "&:hover": {
            bgcolor: "background.paper",
          },
          boxShadow: 2,
        }}
        onClick={onClose}
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>

      <Drawer
        variant="temporary"
        anchor="right"
        sx={{
          paddingBottom: 100,
          display: { xs: "none", sm: "block", md: "flex", lg: "flex" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            transform: true ? "translateX(0)" : "translateX(100%)",
            transition: "transform 0.5s ease-in-out",
          },
        }}
        open={true}
        onClose={onClose}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "100%",
          }}
        >
          <Box
            sx={{
              width: "40%",
              p: 2,
              height: "100%",
              overflow: "hidden",
              backgroundColor: "background.paper",
              borderRight: `1px solid ${appcolors.primary}`,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2 }}>
              Select a client
            </Typography>
            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              <TextInput
                fullWidth
                size="small"
                placeholder="Search for client"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputStartIcon={<SearchIcon style={{ fontSize: 20 }} />}
                handleKeyDown={handleEnterKey}
              />
              <IconButton
                onClick={() => handleSearchClient()}
                sx={{
                  bgcolor: "primary.main",
                  height: "40px",
                  width: "40px",
                  "&:hover": {
                    bgcolor: "primary.dark",
                  },
                }}
              >
                <SearchIcon sx={{ color: "white", fontSize: 20 }} />
              </IconButton>
            </Box>
            <ListItem
              button
              sx={{ mb: 1, mt: 1, padding: "10px 0px" }}
              onClick={() => setOpenModal(true)}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: "primary.main" }}>
                  <AddIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Add new client" />
            </ListItem>

            {filteredClients?.length > 0 ? (
              <List
                sx={{
                  height: "90%",
                  paddingBottom: "60px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  width: "100%",
                  bgcolor: "background.paper",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#d4d2d2",
                    borderRadius: "4px",
                    "&:hover": {
                      background: "#c2c0c0",
                    },
                  },
                }}
              >
                {filteredClients.map((client) => (
                  <ListItem
                    key={client._id}
                    button
                    onClick={() => handleClientSelection(client)}
                    sx={{
                      bgcolor:
                        selectedClient?._id === client?._id
                          ? "primary.light"
                          : "transparent",
                      "&:hover": {
                        bgcolor:
                          selectedClient?._id === client?._id
                            ? "primary.light"
                            : "action.hover",
                      },
                      borderRadius: "4px",
                      mb: 0.5,
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar
                        src={client.image}
                        sx={{
                          bgcolor:
                            selectedClient?._id === client?._id
                              ? "primary.main"
                              : "grey.400",
                        }}
                      >
                        <PersonIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={client.username}
                      secondary={client.email}
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontWeight:
                            selectedClient?._id === client?._id ? 600 : 400,
                          color:
                            selectedClient?._id === client?._id
                              ? "#FFF"
                              : "#000",
                        },
                        "& .MuiListItemText-secondary": {
                          color:
                            selectedClient?._id === client?._id
                              ? "#FFF"
                              : "#000",
                        },
                      }}
                    />
                  </ListItem>
                ))}
                <ListItem
                  key={12}
                  button
                  sx={{ mb: 1, mt: 1, padding: "10px 0px" }}
                />
              </List>
            ) : (
              <Box sx={{ textAlign: "center", p: 2 }}>
                <PersonIcon
                  sx={{ fontSize: 40, color: "primary.main", mb: 2 }}
                />
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
                  No clients found
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Search for clients using their name or email address.
                  <br />
                  <br />
                  Need to add someone new? Click the{" "}
                  <strong>"Add new client"</strong> button above.
                </Typography>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              overflow: "auto",
              maxWidth: "450px",

              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#d4d2d2",
                borderRadius: "4px",
                "&:hover": {
                  background: "#c2c0c0",
                },
              },
            }}
          >
            <DrawerSteps
              activeStep={tabActive}
              setIsLoading={setIsLoading}
              handleCreateTeamData={handleCreateTeamData}
              allTeamMembers={allTeamMembers}
              selectedIds={selectedIds}
              selectedServices={selectedServices}
              handleSelectTeam={handleSelectTeam}
              selectedTeam={payloadData}
              handleSelectedDateTime={handleSelectedDateTime}
              handleCreateAppointment={handleCreateAppointment}
              selectedTime={selectedTime}
              selectedDate={selectedDate}
            />
          </Box>
        </Box>
      </Drawer>
    </>
  );
}
